import type { Essay } from "./types";
import { narrativeCollapse } from "./narrative-collapse";
import { jet2NarrativeHijacking } from "./jet2-narrative-hijacking";
import { starmerMandelsonEpstein } from "./starmer-mandelson-epstein-digital-twin";
import { ferrariLuceLaunch } from "./ferrari-luce-ev-launch";
import { aiCorporateDisclosures } from "./ai-corporate-disclosures";

export const essays: Essay[] = [
  aiCorporateDisclosures,
  ferrariLuceLaunch,
  starmerMandelsonEpstein,
  jet2NarrativeHijacking,
  narrativeCollapse,
];

export const getEssay = (slug: string): Essay | undefined =>
  essays.find((e) => e.slug === slug);
